import React from 'react'
import PropTypes from 'prop-types'
import {
  BreadcrumbRow,
  StyledTextLink,
  SubBannerBackground,
  SubBannerContentWrapper,
  SubBannerWrapper,
  SubBannerText,
  Title,
} from './component.styles'
import { BACK_TO_DASHBOARD_TEXT } from './constants'
import { pageTypes } from 'utils/routing/getPageTypeByUrl'
import SiteSelector, {
  SiteSelectorK8WrapperLight,
  DefaultSiteSelectorWrapper,
} from 'components/SiteSelector'
import { hasBreadcrumbLinks } from 'utils/breadcrumbHelpers'
import { isHighSchoolUrl } from 'utils/routing/routeHelpers'

export const SubLandingBanner = props => {
  const {
    breadcrumb,
    dataTestId = 'default-id',
    isSelaLeaderPage,
    navigateToDashboardOnClick,
    pageType,
    text,
    title,
    shouldShowSiteSelector,
  } = props

  const dataTestIdPrefix = `sublanding-banner`
  const dataTestIdWrapper = `${dataTestIdPrefix}-wrapper-${dataTestId}`
  const dataTestIdHeader = `${dataTestIdPrefix}-header-${dataTestId}`
  const dataTestIdText = `${dataTestIdPrefix}-text-${dataTestId}`

  const isHighSchool = isHighSchoolUrl()
  const showBreadcrumb = hasBreadcrumbLinks(breadcrumb)
  const SiteSelectorWrapper = isHighSchool
    ? DefaultSiteSelectorWrapper
    : SiteSelectorK8WrapperLight

  return (
    <SubBannerWrapper
      $hasBreadcrumb={showBreadcrumb}
      data-testid={dataTestIdWrapper}
    >
      <BreadcrumbRow breadcrumb={breadcrumb} isLight={!isHighSchool}>
        {shouldShowSiteSelector && (
          <SiteSelectorWrapper>
            <SiteSelector />
          </SiteSelectorWrapper>
        )}
      </BreadcrumbRow>
      <SubBannerBackground
        isSelaLeaderPage={isSelaLeaderPage}
        pageType={pageType}
      />
      <SubBannerContentWrapper>
        {pageType === pageTypes.FAMILY_RESOURCE_PAGE && !showBreadcrumb && (
          <StyledTextLink
            dataTestId={'back-to-dashboard-link'}
            onClick={navigateToDashboardOnClick}
          >
            {BACK_TO_DASHBOARD_TEXT}
          </StyledTextLink>
        )}
        <Title data-testid={dataTestIdHeader} pageType={pageType}>
          {title}
        </Title>
        <SubBannerText data-testid={dataTestIdText} pageType={pageType}>
          {text}
        </SubBannerText>
      </SubBannerContentWrapper>
    </SubBannerWrapper>
  )
}

SubLandingBanner.propTypes = {
  breadcrumb: PropTypes.object,
  dataTestId: PropTypes.string,
  isSelaLeaderPage: PropTypes.bool,
  navigateToDashboardOnClick: PropTypes.func.isRequired,
  pageType: PropTypes.string,
  shouldShowSiteSelector: PropTypes.bool,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SubLandingBanner
